import type {ListResult, Valuable} from 'typings/portaro.be.types';
import type {ObservableAjaxService} from './observable-ajax.service';
import type {Observable} from 'rxjs';

/**
 * @ngdoc service
 * @name autocompleteSearchDataService
 * @module portaro.data-services
 *
 * @description
 * Reactive service, that serves data for autocomplete purposes.
 *
 * @requires service:observableAjaxService
 */
export default class AutocompleteSearchDataService {
    public static serviceName = 'autocompleteSearchDataService';
    private baseUri: string;

    /*@ngInject*/
    constructor(private observableAjaxService: ObservableAjaxService) {
        this.baseUri = 'autocomplete';
    }

    /**
     * @ngdoc method
     * @name autocompleteSearchDataService#getSearchedTerms
     *
     * @template TYPE
     *
     * @param {string} infix Searched term
     * @returns {Observable<ListResult<Valuable<TYPE>>>}
     *
     * @description
     * Return stream with results for `searched-terms` autocomplete
     */
    public getSearchedTerms<TYPE = any>(infix: string): Observable<ListResult<Valuable<TYPE>>> {
        return this.observableAjaxService
            .forUri(`${this.baseUri}/searched-terms`)
            .get({infix});
    }
}
